import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf,generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import {  getItemDatosSesion } from '../../funciones_globales/manejosesion';

import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';

const COD_BOTON_EXCEL= '041001';
class FormVen17  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isVisibleBotonExcel:false,
            fechaDesde: null,
            fechaHasta: null,
            tipoCompra: null,
            factura: null,
            zona: null            
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarReporteAnalisisRentabilidad = this.generarReporteAnalisisRentabilidad.bind(this);
        this.generarReporteAnalisisRentabilidadExcel = this.generarReporteAnalisisRentabilidadExcel.bind(this);
    }
    
    componentDidMount(){

        let usuario = getItemDatosSesion('usuario');
    
        Promise.all([
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
          ])
        .then(([ configBotonExcel ]) => {
            let isVisibleBotonExcel = false;
    
            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }
            this.setState({ 
                isVisibleBotonExcel
            });
        })
        .catch(error => {
            alert(error);
        });

        this.props.generar_LogAuditoriaIngresoForm('0417');
        let fechaProceso = getFechaProcesoPorModulo('04');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaHasta.subtract(30, 'days'))
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0417');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Zonas(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('ZONACLIEN', input, callback)
        }
    }

    getOptions_TiposCompra(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('TIPOPRECIO', input, callback)
        }
    }
    generarReporteAnalisisRentabilidadExcel(){        
        try {
            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams=`&rpt=128`;
            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;
            if(this.state.factura){
                urlReportWithParams+=`&param3=${this.state.factura}`;
            }
            if(this.state.zona){
                urlReportWithParams+=`&param4=${this.state.zona.value}`;
            }
            if(this.state.tipoCompra){
                urlReportWithParams+=`&param5=${this.state.tipoCompra.value}`;
            }
                        
            generarReporteEnExcel(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }
    generarReporteAnalisisRentabilidad(){        
        try {
            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams=`&rpt=63`;
            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;
            if(this.state.factura){
                urlReportWithParams+=`&param3=${this.state.factura}`;
            }
            if(this.state.zona){
                urlReportWithParams+=`&param4=${this.state.zona.value}`;
            }
            if(this.state.tipoCompra){
                urlReportWithParams+=`&param5=${this.state.tipoCompra.value}`;
            }
                        
            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaHasta.subtract(30, 'days')),
            tipoCompra: null,
            zona: null    
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Análisis de Rentabilidad</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Categoría:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.tipoCompra} func_loadOptions={this.getOptions_TiposCompra} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({tipoCompra: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Zona:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.zona} func_loadOptions={this.getOptions_Zonas} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({zona: value});}}/>
                        </ContainerCol>
                    </Row>                    
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteAnalisisRentabilidad}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir PDF</button>  
                                {
                                    this.state.isVisibleBotonExcel?
                                    <button type='button' className='btn btn-success btn-sm' onClick={this.generarReporteAnalisisRentabilidadExcel}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir Excel</button>  
                                    :null
                                }
                               
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVen17);